import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Content to be displayed within the disclosure panel */
  children: PropTypes.node.isRequired,
  /** Links the disclosure button to its panel */
  id: PropTypes.string.isRequired,
  /** Label for the disclosure button */
  label: PropTypes.node.isRequired,
  /** Function to call when the disclosure button is clicked */
  onClick: PropTypes.func.isRequired,
  /** Optional content to display inline and before the label */
  headingPrefix: PropTypes.node,
  /** Icon to display in the disclosure button */
  icon: PropTypes.string,
  /** If true, the disclosure panel is expanded */
  isExpanded: PropTypes.bool
};
function Disclosure(_ref) {
  var children = _ref.children,
    headingPrefix = _ref.headingPrefix,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'down-thin' : _ref$icon,
    id = _ref.id,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "disclosure",
    "data-testid": "disclosure"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "label-and-button-container"
  }, headingPrefix, /*#__PURE__*/React__default.createElement("button", {
    "aria-controls": "disclosure-control-".concat(id),
    "aria-expanded": isExpanded,
    id: id,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "disclosure-content",
    "data-testid": "disclosure-content"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "disclosure-label"
  }, label)), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "disclosure-icon",
    "data-icon": icon,
    "data-testid": "disclosure-icon"
  }))), /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": !isExpanded,
    "aria-labelledby": id,
    className: "disclosure-panel",
    id: "disclosure-control-".concat(id),
    role: "region"
  }, children));
}
Disclosure.propTypes = propTypes;

export { Disclosure as default };
//# sourceMappingURL=Disclosure.js.map
